<template>
  <v-container fluid>
    <v-data-table :headers="headers" class="elevation-1" :items="usuarios" :loading="loading">
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters :filters="filters" v-model="filtrosAtivos"></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            depressed
            color="accent"
            :to="{name:'usuarios-formulario'}"
            v-if="perms.includes('auth.criar_usuarios')"
          >
            <v-icon class="mdi mdi-account-plus mr-2" />NOVO USUÁRIO
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-icon
          :class="
            item.ativo
              ? 'mdi mdi-checkbox-marked-outline'
              : 'mdi mdi-checkbox-blank-outline'
          "
        />
      </template>
      <template v-slot:item.acoes="{ item }">
        <v-btn
          icon
          small
          text
          v-if="perms.includes('auth.editar_usuarios')"
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters.vue";
export default {
  components: { DatatableFilters },
  data() {
    return {
      headers: [
        { text: "ID", value: "id" },
        { text: "Login", value: "login" },
        { text: "Nome", value: "nome" },
        { text: "E-mail", value: "email", sortable: false },
        { text: "Ativo", value: "ativo", align: "center" },
        { text: "Ações", value: "acoes", sortable: false, align: "center" }
      ],
      filters: [
        {
          name: "login",
          label: "Login",
          type: "text",
          defaultValue: ""
        },
        {
          name: "nome",
          label: "Nome",
          type: "text",
          defaultValue: ""
        },
        {
          name: "email",
          label: "E-mail",
          type: "text",
          defaultValue: ""
        },
        {
          name: "ativo",
          label: "Ativo",
          type: "switch",
          options: {
            trueValue: "Sim",
            falseValue: "Não"
          },
          defaultValue: true
        }
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.usuarios") || `{"ativo" : true}`
      ),
      loading: true
    };
  },
  computed: {
    ...mapState({
      perms: state => state.usuarios.usuarioAtivo.permissoes,
      usuarios: state => state.usuarios.usuarios
    })
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de usuários"
    });

    this.listar();
  },
  methods: {
    async listar() {
      try {
        this.loading = true;
        await this.$store.dispatch("usuarios/listar", {
          filtros: this.filtrosAtivos
        });
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    editar(id) {
      this.$router.push({ name: "usuarios-formulario-editar", params: { id } });
    }
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.usuarios", JSON.stringify(val));
      this.listar();
    }
  }
};
</script>
